import type { IFileParser } from "./FileParser/IFileParser";

class FileParserRegistry {
	private parsers = new Map<string, IFileParser>();

	register(parser: IFileParser): void {
		for (const ext of parser.supportedExtensions) {
			if (this.parsers.has(ext)) {
				throw new Error(`Parser for .${ext} is already registered`);
			}

			this.parsers.set(ext, parser);
		}
	}

	resolve(fileName: string): IFileParser {
		const ext = fileName.split(".").pop()?.toLowerCase();
		const parser = ext ? this.parsers.get(ext) : undefined;

		if (!parser) {
			const message = `Unsupported file format: ${ext ? `.${ext}` : "unknown"} (file: ${fileName})`;
			throw new Error(message);
		}

		return parser;
	}

	get supportedExtensions(): string[] {
		return [...this.parsers.keys()];
	}
}

export { FileParserRegistry };
